import Glide from '@glidejs/glide';
import CounterChilds from '../../utils/counter-childs';

(() => {
  const selectors = {
    recreationSlide: '.is-recreation-slide',
    relatedSlide: '.is-related-slide'
  };

  function startGlideSlideshow() {
    new Glide('.glide', {
      type: 'slide',
      gap: 0,
      dragThreshold: false
    }).mount();

    const opt = {
      type: 'slide',
      gap: 10,
      perView: 3,
      dragThreshold: false,
      breakpoints: {
        1000: { perView: 3 },
        800: { perView: 2 },
        500: { perView: 1 }
      }
    }

    if (CounterChilds(selectors.recreationSlide) > 0) {
      new Glide(selectors.recreationSlide, opt).mount();
    }

    if (CounterChilds(selectors.relatedSlide) > 0) {
      new Glide(selectors.relatedSlide, opt).mount();
    }
  }

  startGlideSlideshow();
})();